import { defineStore } from 'pinia';
import type { ContactRequest } from '@/types/contactInfo';
import { ContactDraftData } from '@/types/myOrders';
import type { Customer } from '@/types/customers';
import CreateMailoutApi from '@/api';


export const useContactStore = defineStore('contact', {
  state: () => ({
    contactData: null as ContactRequest | null,
    customers: [] as Customer[],
  }),

  actions: {
    saveContact(payload: ContactRequest) {
      this.contactData = payload;
    },
    clearContact() {
      this.contactData = null;
    },
    restoreFromDraft(data: ContactDraftData) {
      this.contactData = data;
    },
    async fetchCustomers() {
      try {
        const response = await CreateMailoutApi.getCustomers();
        this.customers = response.body ?? [];
      } catch (err: unknown) {
        console.error('ContactStore: error loading customers', err);
        throw err;
      }
    },
  },
});
